import type React from 'react';

import { Box } from '@mui/material';

import logoFull from '@/assets/img/logo-knowme.png';
import logoIcon from '@/assets/img/logo_only.png';
import { RouteEnum } from '@/layouts/routes/Route.model.ts';

import { getLogoStyles } from './logo.styles.ts';

interface LogoProps {
  showExpandedContent: boolean;
}

export const Logo: React.FC<LogoProps> = ({ showExpandedContent }) => {
  const handleClick = () => {
    window.location.href = RouteEnum.ROOT;
  };

  return (
    <Box onClick={handleClick} sx={getLogoStyles(showExpandedContent)}>
      <Box sx={{ height: '100%', position: 'relative' }}>
        <img
          alt="knowme icon"
          src={logoIcon}
          style={{
            height: '100%',
            opacity: showExpandedContent ? 0 : 1,
            position: 'absolute',
            transition: 'opacity 0.2s ease-in-out',
          }}
        />
        <img
          alt="knowme logo"
          src={logoFull}
          style={{
            height: '100%',
            opacity: showExpandedContent ? 1 : 0,
            transition: 'opacity 0.2s ease-in-out',
          }}
        />
      </Box>
    </Box>
  );
};
